import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.66669 16C1.66669 8.08391 8.08394 1.66666 16 1.66666C23.9162 1.66666 30.3334 8.08391 30.3334 16C30.3334 23.9161 23.9162 30.3333 16 30.3333C8.08394 30.3333 1.66669 23.9161 1.66669 16ZM22.7071 13.3737C23.0976 12.9832 23.0976 12.3501 22.7071 11.9595C22.3166 11.569 21.6835 11.569 21.293 11.9595L14.6667 18.5857L12.0405 15.9596C11.6499 15.5691 11.0168 15.5691 10.6262 15.9596C10.2357 16.3501 10.2357 16.9832 10.6262 17.3737L13.9596 20.7071C14.1471 20.8947 14.4015 21 14.6667 21C14.9319 21 15.1863 20.8947 15.3738 20.7071L22.7071 13.3737Z",
		fill: "currentColor"
	})
});
export default SvgSuccess;
